export default __webpack_public_path__ + "static/media/ALEXA.5e71bc20.png";